export default "__VITE_ASSET__6TGhW7my__"